import { EStudentConnectionStatus } from '@constants';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

import { EIconType } from '../Icon';

import {
  IconWrapper,
  StyledIcon,
  StyledTag,
  TextWrapper
} from './StudentConnectionStatusTag.styles';

type Props = {
  userConnectionStatus: EStudentConnectionStatus;
  iconOnly?: boolean;
};

const ICON_SIZE = 12;

export const StudentConnectionStatusTag: React.FC<Props> = ({
  userConnectionStatus,
  iconOnly = false
}) => {
  const { colors } = useTheme();
  const { t } = useTranslation();

  if (!userConnectionStatus) return null;

  const STUDENT_CONNECTION_STATUS_INFO: Record<
    EStudentConnectionStatus,
    { color: string; backgroundColor: string; borderColor: string; icon: EIconType }
  > = {
    [EStudentConnectionStatus.WITHOUT_CONNECTION]: {
      color: colors.purple7,
      backgroundColor: colors.purple2,
      borderColor: colors.purple4,
      icon: 'Login'
    },
    [EStudentConnectionStatus.SUPER_USER]: {
      color: colors.green7,
      backgroundColor: colors.green1,
      borderColor: colors.green4,
      icon: 'CheckmarkOutline'
    },
    [EStudentConnectionStatus.ACTIVE]: {
      color: colors.green7,
      backgroundColor: colors.green1,
      borderColor: colors.green4,
      icon: 'CheckmarkOutline'
    },
    [EStudentConnectionStatus.SLEEP]: {
      color: colors.blue7,
      backgroundColor: colors.blue2,
      borderColor: colors.blue4,
      icon: 'WarningAlt'
    },
    [EStudentConnectionStatus.NOT_ACTIVE]: {
      color: colors.red7,
      backgroundColor: colors.red2,
      borderColor: colors.red4,
      icon: 'Flag'
    },
    [EStudentConnectionStatus.DISCONNECTED]: {
      color: colors.red7,
      backgroundColor: colors.red2,
      borderColor: colors.red4,
      icon: 'Flag'
    }
  };
  const { color, backgroundColor, borderColor, icon } =
    STUDENT_CONNECTION_STATUS_INFO[userConnectionStatus];

  if (iconOnly) {
    return (
      <IconWrapper $backgroundColor={backgroundColor} $borderColor={borderColor}>
        <StyledIcon $color={color} i={icon} size={ICON_SIZE} />
      </IconWrapper>
    );
  }

  return (
    <StyledTag $backgroundColor={backgroundColor} $borderColor={borderColor}>
      <StyledIcon $color={color} i={icon} size={ICON_SIZE} />
      <TextWrapper $color={color}>{t(userConnectionStatus)}</TextWrapper>
    </StyledTag>
  );
};
